export const templateTypesWithoutMultisignature = [];
export const templateTypesWithMultiSignatureEnabledByDefault = [
  'agreement',
  'judgment',
  'notification',
];
